var _path, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssessment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.0417 32.5832L35.4584 42.1666L28.7501 35.4582L31.6251 32.5832L35.4584 36.4166L42.1667 29.7082L45.0417 32.5832ZM11.5001 3.83325C9.37258 3.83325 7.66675 5.53909 7.66675 7.66658V38.3332C7.66675 40.4607 9.37258 42.1666 11.5001 42.1666H26.4692C25.4534 40.4224 24.9167 38.4291 24.9167 36.4166C24.9167 35.7841 24.9742 35.1324 25.0701 34.4999H11.5001V30.6666H26.4692C27.3509 29.1332 28.5776 27.7916 30.0534 26.8332H11.5001V22.9999H34.5001V25.0699C35.1326 24.9741 35.7842 24.9166 36.4167 24.9166C37.0684 24.9166 37.7009 24.9741 38.3334 25.0699V15.3333L26.8334 3.83325M24.9167 6.70825L35.4584 17.2499H24.9167V6.70825Z",
    fill: "#FF7575"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 29.8183,
    y1: 33.9544,
    x2: 36.091,
    y2: 40.2271,
    stroke: "#80C465",
    strokeWidth: 4.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 33.9544,
    y1: 41.2725,
    x2: 44.409,
    y2: 30.818,
    stroke: "#80C465",
    strokeWidth: 4.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessment);
export default __webpack_public_path__ + "static/media/assessment.67efb49246b9d470178ab861b8ce9130.svg";
export { ForwardRef as ReactComponent };